// @flow
export { BanksSPA } from './BanksSPA';
export { BankDisclaimer } from './BankDisclaimer';
